import type { AppRoute } from "@/lib/routing";
import { SuppliersPage } from "./pages/SuppliersPage";

export const routes: AppRoute[] = [
  {
    path: "/suppliers",
    element: <SuppliersPage />,
    handle: { title: "Suppliers", keywords: ["vendors", "shops", "shipping", "catalog", "sync", "continuity"] },
  },
  {
    path: "/suppliers/:id",
    lazy: async () => ({ Component: (await import("./pages/SupplierDetailPage")).SupplierDetailPage }),
    handle: { title: "Supplier" },
  },
];
